export default class ModalFormBuilderSelectController {
	/* @ngInject */
	constructor($uibModalInstance, $location, forms, classKid) {
		this.$uibModalInstance = $uibModalInstance;
		this.$location = $location;
		this.forms = forms;
		this.classKid = classKid;
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}

	createNewForm() {
		this.$uibModalInstance.close();
		this.$location.path(`/form-builder/new/${this.classKid}`);
	}

	openForm(form) {
		this.$uibModalInstance.close(form);
	}
}
